module.exports = __webpack_public_path__ + "img/universal.899ca6b8.png";